import { Button } from '@/components/ui/button';
import { useLingui } from '@lingui/react';
import { msg, t } from '@lingui/macro';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ContractWizardFooterProps {
  currentStep: string;
  stepIndex: number;
  canNavigateNext: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
  onCancel: () => void;
}

export function ContractWizardFooter({
  currentStep,
  stepIndex,
  canNavigateNext,
  isSubmitting,
  onBack,
  onNext,
  onCancel,
}: ContractWizardFooterProps) {
  const { i18n } = useLingui();
  const isReviewStep = currentStep === 'review';
  const isFirstStep = stepIndex === 0;

  return (
    <div className="px-6 py-4 border-t">
      <div className="flex justify-between">
        <Button
          variant="outline"
          onClick={onCancel}
          aria-label={i18n._(msg`Cancel and close wizard`)}
        >
          {i18n._(t({ id: "common.cancel", message: "Cancel" }))}
        </Button>
        
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={onBack}
            disabled={isFirstStep}
            aria-label={i18n._(msg`Go back to previous step (Alt+B)`)}
            title={i18n._(msg`Go back (Alt+B)`)}
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            {i18n._(msg`Back`)}
          </Button>
          
          <Button
            onClick={onNext}
            disabled={!canNavigateNext || isSubmitting}
            aria-label={
              isReviewStep 
                ? i18n._(msg`Submit contract`) 
                : i18n._(msg`Go to next step (Alt+N)`)
            }
            title={
              isReviewStep 
                ? i18n._(msg`Submit contract`) 
                : i18n._(msg`Go to next step (Alt+N)`)
            }
          >
            {isReviewStep 
              ? i18n._(msg`Submit`) 
              : i18n._(msg`Next`)}
            {!isReviewStep && (
              <ChevronRight className="h-4 w-4 ml-1" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
